import { render, staticRenderFns } from "./PontosResgateInput.vue?vue&type=template&id=3063497c&"
import script from "./PontosResgateInput.vue?vue&type=script&lang=js&"
export * from "./PontosResgateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports